import { render, staticRenderFns } from "./df-card-special.vue?vue&type=template&id=6ccf91e5&"
import script from "./df-card-special.ts?vue&type=script&lang=js&"
export * from "./df-card-special.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports